import SVG from '@/components/SVG/SVG';
import React from 'react';
import { t } from 'i18next';
import CircularProgress from '@mui/material/CircularProgress';

type P = {
  title?: string;
  isLoading: boolean;
};

const RequestSearch = ({ title, isLoading }: P) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        padding: '73px 107px',
      }}
    >
      {isLoading ? (
        <CircularProgress
          size={'30px'}
          style={{
            color: 'var(--dk-text-dim, #b7bbc2)',
            alignSelf: 'center',
          }}
        />
      ) : (
        <>
          <SVG
            name="empty"
            width={40}
            height={40}
            viewBox="0 0 40 40"
            className="empty svg-icon"
          />
          <div
            style={{
              color: 'var(--dk-text-dim, #B7BBC2)',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '20px',
              textAlign: 'center',
            }}
          >
            {title ? title : t('찾고자 하는 품의를 검색해 주세요.')}
          </div>
        </>
      )}
    </div>
  );
};
export default RequestSearch;
